import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const ServiceCards = ({ services, more }) => (
  <ul className="grid gap-5 md:grid-cols-2">
    {services.map((s, i) => (
      <Reveal as="li" key={s.slug} delay={i * 120}>
        <Link to={`/services/${s.slug}`} className="group card-soft flex h-full flex-col p-8 transition-colors duration-500 hover:border-[#6F5B9E]/50 hover:bg-[#F5F1FA] sm:p-10" data-testid={`service-offered-card-${s.slug}`}>
          <span className="font-display text-lg text-[#B9A9D8]">{String(i + 1).padStart(2, "0")}</span>
          <span className="mt-6 font-display text-3xl leading-snug text-[#22304A] sm:text-4xl">{s.title}</span>
          <span className="mt-4 leading-relaxed text-[#22304A]/70">{s.intro || s.areas.map((a) => a.title).join(" · ")}</span>
          <span className="mt-auto inline-flex items-center gap-2 pt-8 text-[15px] font-medium text-[#6F5B9E]">
            {more} <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" aria-hidden="true" />
          </span>
        </Link>
      </Reveal>
    ))}
  </ul>
);
